import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import CompanyLookup from "../../Partials/Lookup/CompanyLookup";
import Time from "../../../Time/Time";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import Constants from "../../../Action/Constants";
import Button from '@material-ui/core/Button';
import Select from "../../Partials/Material/Select";
import TextField from "../../Partials/Material/TextField";
import Card from '@material-ui/core/Card';
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import PersonCreateWillMount from "../../../Middleware/Middlewares/PersonCreateWillMount";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { Attachment } from "../../Partials/Attachment/Attachment";
import * as uuidV4 from "uuid/v4";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";

class PersonCreate extends Component {
  private pageTemplate: string;

  public state = {
    firstName: "",
    lastName: "",
    email: "",
    role: null,
    phone1: "",
    phone2: "",
    profession: "",
    personAddress: {
      formattedAddress: ""
    },
    dateOfBirth: null,
    identityNumber: "",
    mainBankAccountId: "",
    mainBankAccountName: "",
    identityType: 255,
    company: {
      id: null,
      avatar: this.image.get("company"),
      displayName: ""
    },
    amazonFolderName: uuidV4(),
    openLeavePrompt: false,
    note: "",
    hasModifiedData: false,
    isSaving: false,
    ibanUsedForEntity: null,
    attachments: [],
    genderTypeId: 3,
    languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2,

    documentAddress: {
      formattedAddress: "",
    },
    placeOfBirthAddress: {
      formattedAddress: "",
    },
    companyRole: "",
    additionalFields: [],
    lastSelectedIndex: null,
    newCompanyName: "",
    isCreateCompanyPopupOpen: false
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_CONTACT_PERSON_CREATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    PersonCreateWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);
  }

  public getPayload = (): any => {
    let pageTemplate = "person";

    if (this.props.location.pathname.includes("tenant")) {
      pageTemplate = "tenant";
    }

    if (this.props.location.pathname.includes("executor")) {
      pageTemplate = "executor";
    }

    if (this.props.location.pathname.includes("caretaker")) {
      pageTemplate = "caretaker";
    }

    return {
      person: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        profession: this.state.profession,
        email: this.state.email,
        phone1: this.state.phone1,
        phone2: this.state.phone2,
        contactRoleId: this.state.role,
        mainBankAccountId: this.state.mainBankAccountId,
        mainBankAccountName: this.state.mainBankAccountName,
        bankAccount: {
          accountId: this.state.mainBankAccountId,
          name: this.state.mainBankAccountName
        },
        companyId: this.state.company.id,
        company: this.state.company,
        address: Object.keys(this.state.personAddress || {}).length > 0 ? { ...this.state.personAddress } : null,
        dateOfBirth: Time.formatOrNull(this.state.dateOfBirth),
        placeOfBirth: this.state.placeOfBirthAddress,
        identityNumber: this.state.identityNumber,
        identityType: this.state.identityType,
        amazonFolderName: this.state.amazonFolderName,
        note: this.state.note,
        pageTemplate: pageTemplate,
        genderTypeId: this.state.genderTypeId,
        languageTypeId: this.state.languageTypeId,
        documentAddress: this.state.documentAddress,
        additionalFields: [...this.state.additionalFields],
        companyRole: this.state.companyRole
      }
    };
  }

  public save = () => {
    const iban = this.state.mainBankAccountId;

    if (iban) {
      const company: CompanyInterface = this.props.app.companies.filter(company => !company.removed).find((company: CompanyInterface) => company.mainBankAccountId === this.state.mainBankAccountId);
      const person: PersonInterface = this.props.app.persons.filter(person => !person.removed).find((person: PersonInterface) => person.mainBankAccountId === this.state.mainBankAccountId);

      if (!!person ) {
        this.setState({
          ibanUsedForEntity: person
        });
      }

      if (!!company ) {
        this.setState({
          ibanUsedForEntity: company
        });
      }
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
        payload: this.getPayload(),
        onSuccess: person => {

          const savedDataBeforeRedirecting = {...this.props.app.savedDataBeforeRedirecting};
          const indexForAdditionalPerson = savedDataBeforeRedirecting.indexForAdditionalPerson;
          const additionalFields = savedDataBeforeRedirecting.dataToBeSaved &&
            savedDataBeforeRedirecting.dataToBeSaved.additionalFields ?
            [...savedDataBeforeRedirecting.dataToBeSaved.additionalFields] : [];
          let additionalPersonField = null;

          if (Number.isInteger(indexForAdditionalPerson)) {
            additionalPersonField = {...additionalFields[indexForAdditionalPerson]};
          }

          if (additionalPersonField) {
            additionalPersonField.selectedPerson = person;
            additionalFields[indexForAdditionalPerson] = additionalPersonField;

            this.props.dispatch({
              type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
            });

            savedDataBeforeRedirecting.dataToBeSaved.additionalFields = [...additionalFields];

            this.props.dispatch({
              type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
              payload: {
                savedDataBeforeRedirecting: {...savedDataBeforeRedirecting}
              }
            });
          } else {
            if (this.props.location.pathname.includes("executor")) {
              savedDataBeforeRedirecting.createdExecutor = person;
            } else {
              savedDataBeforeRedirecting.createdPerson = person;
            }

            if (!!savedDataBeforeRedirecting.statePropertyName) {
              savedDataBeforeRedirecting[savedDataBeforeRedirecting.statePropertyName] = person;
            }

            this.props.dispatch({
              type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
            });

            this.props.dispatch({
              type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
              payload: {
                savedDataBeforeRedirecting: {...savedDataBeforeRedirecting}
              }
            });
          }

          return this.redirectBack();
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public clearCompany = (): any => {
    this.setState({
      company: {
        id: null,
        avatar: this.image.get("company"),
        displayName: ""
      }
    });
  }

  public getTitle = () => {
    if (this.props.location.pathname.includes("tenant")) {
      return this.trans("new-tenant");
    }

    if (this.props.location.pathname.includes("executor")) {
      return this.trans("new-executor");
    }

    if (this.props.location.pathname.includes("caretaker")) {
      return this.trans("managercreate-newmanager-title");
    }

    return this.trans("personcreate-newperson-title");
  }

  public getAttachmentsTitle = () => {
    if (this.props.location.pathname.includes("person")) {
      return this.trans("attachments-for-person");
    }

    if (this.props.location.pathname.includes("caretaker")) {
      return this.trans("attachments-for-caretaker");
    }

    if (this.props.location.pathname.includes("tenant")) {
      return this.trans("attachments-for-tenant");
    }

    if (this.props.location.pathname.includes("executor")) {
      return this.trans("attachments-for-executor");
    }
  }

  public selectIdentityDocumentType = (event): void => {
    const type: number = event.target.value;

    this.setState({identityType: type});
  }

  public selectPlaceOfBirth = (event) => {
    this.setState({
      hasModifiedData: true,
      placeOfBirthAddress: event,
    })
  }

  public clearPlaceOfBirth = () => {
    this.setState({
      hasModifiedData: true,
      placeOfBirthAddress: {
        formattedAddress: "",
      }
    })
  }

    public selectCountry = (event) => {
    this.setState({
      hasModifiedData: true,
      documentAddress: event,
    })
  }

  public clearCountry = () => {
    this.setState({
      hasModifiedData: true,
      documentAddress: {
        formattedAddress: "",
      }
    })
  }

  public selectCompany = (company: CompanyInterface, isManuallySelected: boolean): void  => {
    this.setState({
      avatar: company.avatar,
      company: company,
      hasModifiedData: isManuallySelected
    });
  }

  public addAdditionalFields = (): void => {
    const additionalFields = [...this.state.additionalFields];

    additionalFields.push({
      selectedCompany: null,
      role: ""
    });

    this.setState({additionalFields: [...additionalFields]});

    this.forceUpdate();
  }

  public renderAdditionalFields = (): any => {
    return this.state.additionalFields.map((data: any, index: number) => {
      if (!data) {
        return;
      }

      return (
        <div
          key={`additional-field-${index}`}
          style={{display: "flex", position: "relative", margin: "0px 0px -14px 0px"}}
        >
          <CompanyLookup
            {...this.props}
            filterOutEntities={this.state.additionalFields}
            isInlineBlock={true}
            width="100%"
            containerWidth="60%"
            onFocus={() => this.setState({lastSelectedIndex: index}) }
            autoSelectId={data && data.selectedCompany ? data && data.selectedCompany.id : null}
            floatingLabelText={this.trans("dropdown-searchforcompany-label") + this.trans("field/optional")}
            onSelect={this.selectAdditionalCompany}
            onClear={_company => {
              const additionalFields = [...this.state.additionalFields];
              additionalFields[index].selectedCompany = null;

              this.setState({
                additionalFields: [...additionalFields]
              }, () => {
                this.setModifiedData();
              });
            }}
            shouldOpenCoachModal={true}
            openCreateCompanyDialog={() => {
              this.props.dispatch({
                type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
              });

              this.setState({isCreateCompanyPopupOpen: true});
            }}
          />

          <TextField
            autoComplete="off"
            className="form-element"
            style={{ width: "30%", boxSizing: "border-box", marginLeft: "45px" }}
            type="text"
            label={this.trans("role") + this.trans("field/optional")}
            value={this.state.additionalFields[index].role}
            onChange={e => {
              const additionalFields = [...this.state.additionalFields];
              additionalFields[index].role = (e.currentTarget as any).value;
              this.setState({additionalFields: [...additionalFields]});
              this.setModifiedData();
            }}
            variant="standard"
            error={false}
          />

          <div
            className="icon icon-ic-close clear-button"
            style={{
              display: "inline-block",
              position: "absolute",
              top: "28px",
              right: "-20px",
              cursor: "pointer"
            }}
            onClick={this.removeAdditionalField.bind(this, index)}
          ></div>
        </div>
      );
    });
  }

  public removeAdditionalField = (index: number): void => {
    const additionalFields = [...this.state.additionalFields];
    additionalFields.splice(index, 1);

    this.setState({
      additionalFields: [...additionalFields],
      hasModifiedData: true
    });

    this.forceUpdate();
  }

  public selectAdditionalCompany = (company: CompanyInterface, isManuallySelected: boolean): void => {
    const additionalFields = [...this.state.additionalFields];

    if (isManuallySelected === true) {
      additionalFields[this.state.lastSelectedIndex].selectedCompany = company;
    }

    this.setState({
      hasModifiedData: isManuallySelected,
      additionalFields: [...additionalFields]
    });
  }

  public createCompany = () => {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
      payload: {
        company: {
          name: this.state.newCompanyName,
          pageTemplate: "company"
        }
      },
      onSuccess: company => {
        if (typeof this.state.lastSelectedIndex === "number") {
          if (this.state.lastSelectedIndex === -1) {
            this.setState({
              company: company
            })
          } else {
            const additionalFields = [...this.state.additionalFields];
            additionalFields[this.state.lastSelectedIndex]["selectedCompany"] = company;

            this.setState({
              additionalFields: additionalFields
            })
          }
        }

        this.setState({
          isCreateCompanyPopupOpen: false,
          newCompanyName: ""
        })
      },
      onError: () => {
      }
    });
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.getTitle()}</h1>
              <div className="button-container" style={{minWidth: "initial"}}>
                <Button
                  color="primary"
                  onClick={this.cancel.bind(this)}
                  style={{marginRight: "20px"}}
                >
                  {this.trans("button-cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.save}
                  disabled={this.state.isSaving}
                >
                  {this.state.isSaving === true ? this.trans("button-saving") : this.trans("button-create")}
                </Button>
              </div>
            </div>
          </div>

          <div className="box component-person-create">
            <div className="component-wrapper no-margin-top">
              <div className="component">
                <Card className="card">
                  <div style={{maxWidth: "420px", padding: "10px 40px 10px 10px"}}>
                    <form>
                      <TextField
                        autoComplete="off"
                        // id="firstName"
                        // name="firstName"
                        className="form-element full-size scroll-to-firstName"
                        type="text"
                        label={this.trans("label-first-name")}
                        value={this.state.firstName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
                        autoFocus={true}
                        variant="standard"
                        error={!!this.getErrorFor("firstName")}
                        helperText={this.getErrorFor("firstName")}
                      />

                      <TextField
                        autoComplete="off"
                        // id="lastName"
                        // name="lastName"
                        className="form-element full-size scroll-to-lastName"
                        type="text"
                        label={this.trans("label-last-name") + this.trans("field/optional")}
                        value={this.state.lastName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "lastName")}
                        variant="standard"
                        error={!!this.getErrorFor("lastName")}
                        helperText={this.getErrorFor("lastName")}
                      />

                      <div style={{display: "flex", margin: "-14px 0"}}>
                        <CompanyLookup
                          {...this.props}
                          className="scroll-to-companyId"
                          isInlineBlock={true}
                          width="100%"
                          containerWidth="60%"
                          floatingLabelText={this.trans("dropdown-searchforcompany-label") + this.trans("field/optional")}
                          searchText={this.state.company && this.state.company.displayName}
                          autoSelectId={this.state.company && this.state.company.id}
                          onFocus={() => this.setState({lastSelectedIndex: -1}) }
                          onClear={this.clearCompany}
                          onSelect={this.selectCompany}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "personCreate")}
                          shouldOpenCoachModal={true}
                          openCreateCompanyDialog={() => {
                            this.props.dispatch({
                              type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
                            });
              
                            this.setState({isCreateCompanyPopupOpen: true});
                          }}
                        />

                        <TextField
                          style={{ width: "30%", boxSizing: "border-box", marginLeft: "45px" }}
                          autoComplete="off"
                          // id="profession"
                          // name="profession"
                          className="form-element"
                          type="text"
                          label={this.trans("role") + this.trans("field/optional")}
                          value={this.state.companyRole}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "companyRole")}
                          variant="standard"
                          error={!!this.getErrorFor("role")}
                        />
                      </div>

                      <div className="hint-styles-wrapper">
                        <span className="hint-styles">{this.trans("page/personcreateupdate-company-info")}</span>
                      </div>

                      {this.renderAdditionalFields()}

                      <Button
                        color="primary"
                        style={{
                          width: "60%",
                          boxSizing: "border-box",
                          border: "1px solid rgba(0,0,0,.1)",
                          display: "inline-block",
                          margin: "10px 0px 0px 0px"
                        }}
                        className="plus-button"
                        onClick={this.addAdditionalFields}
                      >
                        {this.trans("button-new-company")}
                      </Button>

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-email"
                        label={this.trans("label-email") + this.trans("field/optional")}
                        value={this.state.email}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "email")}
                        variant="standard"
                        error={!!this.getErrorFor("email")}
                        helperText={this.getErrorFor("email")}
                      />

                      <div style={{margin: "-14px 0"}}>
                        <TextField
                          autoComplete="off"
                          // id="phone1"
                          //name="phone1"
                          className="form-element half-size scroll-to-phone1 textfield-width-half"
                          type="text"
                          label={this.trans("label-mob-number") + this.trans("field/optional")}
                          value={this.state.phone1}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone1")}
                          variant="standard"
                          error={!!this.getErrorFor("phone1")}
                          helperText={this.getErrorFor("phone1")}
                        />

                        <TextField
                          autoComplete="off"
                          // id="phone2"
                          // name="phone2"
                          className="form-element half-size scroll-to-phone2 textfield-width-half"
                          type="text"
                          label={this.trans("other-phone") + this.trans("field/optional")}
                          value={this.state.phone2}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone2")}
                          variant="standard"
                          error={!!this.getErrorFor("phone2")}
                          helperText={this.getErrorFor("phone2")}
                        />
                      </div>

                      <Select
                        className="form-element full-size form-input scroll-to-genderTypeId correct-label-position"
                        variant="standard"
                        error={this.getErrorFor("genderTypeId")}
                        value={this.state.genderTypeId}
                        onChange={this.sync.bind(this, this.syncronizers.GENDER_TYPE)}
                        htmlFor="genderType"
                        label={this.trans("gender-type") + this.trans("field/optional")}
                        name="genderType" 
                        id="genderType"
                      >
                        {this.getGenderTypeSelectboxes()}
                      </Select>


                      <Select
                        className="form-element full-size form-input scroll-to-languageType correct-label-position"
                        variant="standard"
                        error={this.getErrorFor("languageTypeId")}
                        value={this.state.languageTypeId}
                        onChange={this.sync.bind(this, this.syncronizers.LANGUAGE_TYPE)}
                        htmlFor="languageType"
                        label={this.trans("language-type") + this.trans("field/optional")}
                        name="languageType" 
                        id="languageType"
                      >
                        {this.getLanguageTypeSelectboxes()}
                      </Select>

                      {this.pageTemplate !== "caretaker" && (
                        <React.Fragment>
                          <DatePickerComponent
                            {...this.props}
                            // id="dateOfBirth"
                            // name="dateOfBirth"
                            className="scroll-to-dateOfBirth"
                            label={this.trans("date-of-birth") + this.trans("field/optional")}
                            initialDate={this.state.dateOfBirth}
                            onChange={date => this.setState({ dateOfBirth: date, hasModifiedData: true })}
                            clearButton={true}
                            error={this.getErrorFor("dateOfBirth")}
                          />

                          <AddressSelector
                            {...this.props}
                            // id="address"
                            // name="address.googlePlaceId"
                            className="scroll-to-documentAddress"
                            labelText={this.trans("place-of-birth") + this.trans("field/optional")}
                            searchText={this.state.placeOfBirthAddress.formattedAddress ? this.state.placeOfBirthAddress.formattedAddress : null}
                            selectedAddress={this.state.placeOfBirthAddress}
                            onSelect={this.selectPlaceOfBirth}
                            onClear={this.clearPlaceOfBirth}
                            //countryList={true}
                            error={this.getErrorFor("placeOfBirth")}
                          />

                          <Select
                            className="form-element full-size form-input scroll-to-identityType correct-label-position"
                            variant="standard"
                            error={this.getErrorFor("identityType")}
                            value={this.state.identityType}
                            onChange={this.selectIdentityDocumentType}
                            htmlFor="identityDocumentType"
                            label={this.trans("identity-document-type") + this.trans("field/optional")}
                            name="identityDocumentType" 
                            id="identityDocumentType"
                          >
                            {this.getIdentityTypeSelectboxes()}
                          </Select>

                          <TextField
                            autoComplete="off"
                            // id="identityNumber"
                            // name="identityNumber"
                            className="form-element full-size scroll-to-identityNumber"
                            type="text"
                            label={this.trans("identity-document-number") + this.trans("field/optional")}
                            value={this.state.identityNumber}
                            onChange={this.sync.bind(this, this.syncronizers.EVENT, "identityNumber")}
                            variant="standard"
                            error={!!this.getErrorFor("identityNumber")}
                            helperText={this.getErrorFor("identityNumber")}
                          />

                          <AddressSelector
                            {...this.props}
                            // id="address"
                            // name="address.googlePlaceId"
                            className="scroll-to-documentAddress"
                            labelText={this.trans("dropdown/documentcountry-label") + this.trans("field/optional")}
                            searchText={this.state.documentAddress.formattedAddress ? this.state.documentAddress.formattedAddress : null}
                            selectedAddress={this.state.documentAddress}
                            onSelect={this.selectCountry}
                            onClear={this.clearCountry}
                            countryList={true}
                          />
                        </React.Fragment>
                      )}
                      
                      <AddressSelector
                        {...this.props}
                        id="address"
                        name="address.googlePlaceId"
                        className="scroll-to-address"
                        searchText={this.state.personAddress.formattedAddress ? this.state.personAddress.formattedAddress : null}
                        selectedAddress={this.state.personAddress}
                        onSelect={this.sync.bind(this, this.syncronizers.VALUE, "personAddress")}
                        onClear={this.sync.bind(this, this.syncronizers.VALUE, "personAddress", {})}
                      />

                      <TextField
                        autoComplete="off"
                        // id="bankAccountId"
                        // name="bankAccountId"
                        className="form-element full-size scroll-to-mainBankAccountId"
                        type="text"
                        label={this.trans("label-bank-account-id") + this.trans("field/optional")}
                        value={this.state.mainBankAccountId}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountId")}
                        variant="standard"
                        error={!!this.getErrorFor("bankAccount.accountId")}
                        helperText={this.getErrorFor("bankAccount.accountId")}
                      />

                      <TextField
                        autoComplete="off"
                        // id="mainBankAccountName"
                        // name="mainBankAccountName"
                        className="form-element full-size scroll-to-mainBankAccountName"
                        type="text"
                        label={this.trans("label-bank-account-name") + this.trans("field/optional")}
                        value={this.state.mainBankAccountName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountName")}
                        variant="standard"
                        error={!!this.getErrorFor("mainBankAccountName")}
                        helperText={this.getErrorFor("mainBankAccountName")}
                      /> 

                      <TextField
                        autoComplete="off"
                        // id="note"
                        // name="note"
                        className="form-element full-size scroll-to-note"
                        type="text"
                        multiline={true}
                        rowsMax={10}
                        label={this.trans("note") + this.trans("field/optional")}
                        value={this.state.note}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                        variant="standard"
                        error={!!this.getErrorFor("note")}
                        helperText={this.getErrorFor("note")}
                      />
                    </form>
                  </div>
                </Card>
              </div>
            </div>

            <div className="component-wrapper">
              <Attachment
                {...this.props}
                typeOfComponent="shared"
                possibilityToSetAvatar={true}
                title={this.getAttachmentsTitle()}
                relation="contactId"
                onAmazonFolderNameGeneration={!this.state.amazonFolderName ?
                  this.sync.bind(this, this.syncronizers.VALUE, "amazonFolderName") : null}
                amazonFolderName={!!this.state.amazonFolderName ? this.state.amazonFolderName : null}
                attachments={this.state.attachments}
                updateParentState={attachments => this.setState({attachments: attachments})}
                onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
                onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
              />
            </div>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isCreateCompanyPopupOpen}
          title={this.trans("title-new-company")}
          content={
            <div>
              <TextField
                autoComplete="off"
                className="form-element full-size scroll-to-name"
                type="text"
                label={this.trans("label-company-name")}
                value={this.state.newCompanyName}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "newCompanyName")}
                autoFocus={true}
                variant="standard"
                error={!!this.getErrorFor("name")}
              />
              {!!this.getErrorFor("name") && <div className="component-error-text">{this.getErrorFor("name")}</div>}
            </div>
          }
          positiveButtonLabel={this.trans("dialog-button/create")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={this.createCompany}
          onDiscard={() => this.setState({ isCreateCompanyPopupOpen: false, newCompanyName: "" }) }
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.personCreate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps, null, null, { withRef: true })(
  PersonCreate
);
